import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_ATTACHMENT_TYPES';

export async function getAllAttachmentTypes(
    userToken: string,
    params = "",
    page = 1
) {
    try {
         

        const response = await axios.get(
             
            `${URL}/attachment-types/?page=${page}&${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de récuperation de la liste types des pièces jointes',
            error: error
        });
    }
}
